import { computed } from '@vue/composition-api';

/**
 * Composable for the "pipeline" expiring contracts section.
 * Uses the shared Daily Digest instance to derive expiring_contracts.
 *
 * @param {Object} params - Configuration
 * @param {Object} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {Object} params.loading - loading ref from useDailyDigest
 * @returns {Object} Object containing reactive state for pipeline expiring contracts section
 */
export function usePipelineExpiringContractsSection({ dailyDigest, loading }) {
  /**
   * Pipeline expiring contracts from daily digest data.
   * @returns {Array} Array of pipeline expiring contract objects, or empty array if none available
   */
  const pipelineExpiringContracts = computed(() => {
    const contracts = dailyDigest.value?.expiring_contracts || [];
    // Debug: inspect pipeline expiring contracts coming from dailyDigest
    // eslint-disable-next-line no-console
    console.log(
      '[usePipelineExpiringContractsSection] expiring_contracts count:',
      Array.isArray(contracts) ? contracts.length : 0,
      contracts
    );
    return contracts;
  });

  /**
   * Reuse the shared loading state from the Daily Digest composable.
   */
  const loadingPipelineExpiringContracts = loading;

  return {
    pipelineExpiringContracts,
    loading: loadingPipelineExpiringContracts
  };
}

